import { c as _c } from "react-compiler-runtime";
import { createContext, useCallback, useContext } from 'react';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import I18n from 'I18n';
import { VerticalMenuIcon } from 'foundations-assets/icons/components/VerticalMenuIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const FDTContextMenuConfigContext = /*#__PURE__*/createContext({});
export const ProvideFDTContextMenuConfig = t0 => {
  const $ = _c(5);
  const {
    contextMenuConfig,
    children
  } = t0;
  let t1;
  if ($[0] !== contextMenuConfig) {
    t1 = {
      contextMenuConfig
    };
    $[0] = contextMenuConfig;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = /*#__PURE__*/_jsx(FDTContextMenuConfigContext.Provider, {
      value: t1,
      children: children
    });
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const useFDTContextMenuConfig = () => {
  const {
    contextMenuConfig
  } = useContext(FDTContextMenuConfigContext);
  return contextMenuConfig;
};
export const useIsFDTContextMenuEnabled = () => {
  const contextMenuConfig = useFDTContextMenuConfig();
  return Boolean(contextMenuConfig);
};

/** When clicked will call `triggerContextMenu` with the columnNamespace, columnName, and row=null as arguments
 * Will conditionally render itself to not render when triggerContextMenu is not provided
 * Uses getIsContextMenuOpen to determine if the popover should be shown
 */
export const ContextMenuHeaderTriggerButton = t0 => {
  const $ = _c(8);
  const {
    columnNamespace,
    columnName
  } = t0;
  const contextMenuConfig = useFDTContextMenuConfig();
  const triggerContextMenu = contextMenuConfig === null || contextMenuConfig === void 0 ? void 0 : contextMenuConfig.triggerContextMenu;
  let t1;
  if ($[0] !== columnName || $[1] !== columnNamespace || $[2] !== triggerContextMenu) {
    t1 = e => {
      e.preventDefault();
      e.stopPropagation();
      if (triggerContextMenu) {
        triggerContextMenu({
          row: null,
          columnName,
          columnNamespace
        });
      }
    };
    $[0] = columnName;
    $[1] = columnNamespace;
    $[2] = triggerContextMenu;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  if (!triggerContextMenu) {
    return null;
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = I18n.text("datatable.contextMenu.openContextMenu");
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(VerticalMenuIcon, {});
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleClick) {
    t4 = /*#__PURE__*/_jsx(IconButton, {
      "aria-label": t2,
      onClick: handleClick,
      size: "extra-small",
      use: "transparent",
      children: t3
    });
    $[6] = handleClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};